<template>
  <MenuComponent>
    <template #navbar="{ navbarMini }">
      <ReleasesNavBar
        :loading.sync="loading"
        :mini="navbarMini"
        :release.sync="release"
        :releases.sync="releases"
        type="realeases"/>
    </template>
    <template
      v-if="filtred_count"
      #filtered_items>
      {{ filtred_count }}
    </template>
    <template #filter>
      <FilterBar
        :all-headers="filters"
        @applyFilters="filterByTypes"
        @applySearch="applySearch">
        <template #third_activator="{item}">
          <TypeSelect
            :value.sync="item.search"/>
        </template>
      </FilterBar>
    </template>
    <template
      v-if="!loading"
      #items>
      <div
        v-if="!release || !release.features || !release.features.length || !filtred_features.length"
        :key="filtred_features.length"
        class="empty-block main__light_green h5-headline text-start
        py-16 px-12 mr-7 mt-4 black--text">
        <template v-if="release && release.id">
          <div class="mb-5">
            {{ $t('Releases.NoDescriptions') }}
          </div>
          <sButton
            icon="plus"
            icon-size="12px"
            :to="{name:'newFeature', params: {releaseId: release.id} }"
            type="border">
            {{ $t('Releases.OpenDescription') }}
          </sButton>
        </template>
        <template v-else>
          <div class="mb-5">
            {{ $t('Releases.NoReleases') }}
          </div>
          <CreateRelease btn/>
        </template>
      </div>
      <div
        v-else
        class="mt-4">
        <FeatureCard
          v-for="item in filtred_features "
          :key="item.id"
          :item="item"
          :release.sync="release"
          @action="applySearch"/>
      </div>
    </template>
    <template #loader>
      <InfinityUpdater
        ref="infinity_updater"
        :action="infinityLoad"
        :active="can_update"
        :loading="loading || loadi_features"/>
    </template>
  </MenuComponent>
</template>

<script>
import TypeSelect from 'components/releases/TypeSelect.vue'
import MenuComponent from 'pages/templates/MenuComponent.vue'
import FeatureCard from 'components/releases/FeatureCard.vue'
import FilterBar from 'components/common/blocks/FilterBar.vue'
import CreateRelease from 'components/releases/CreateRelease.vue'
import ReleasesNavBar from 'components/releases/ReleasesNavBar.vue'
import InfinityUpdater from 'components/extends/InfinityUpdater.vue'

import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  name: 'createReleases',
  data() {
    return {
      loading: false,
      loadi_features: false,
      release: {},
      search: '',
      filtred_features: [],
      features: [],
      type_filter: '',
      count: 0
    }
  },
  created() {
    this.loading = true
    this.$store.dispatch('getFeatureDetail')
    this.$store.dispatch('getReleases')
      .finally(() => {
        this.loading = false
      })
  },
  computed: {
    ...mapGetters({
      releases: 'getReleases'
    }),
    can_update() {
      return this.features?.length < this.release.count && !this.loadi_features && !this.loading
    },
    per_page() {
      let elm = this.$el
      return Math.floor((elm?.clientHeight || 0) / 120)
    },
    // features() {
    //   return this.release.features
    // },
    filters() {
      return [
        {setFilter: true,
          text: this.$t('Common.Type'),
          value: 'type',
          search: 'type' }
      ]
    },
    filtred_count() {
      if ( this.release && this.release.publishName ) {
        return ' "' +  this.release.publishName + '" ' + this.$t('Purchasing.From') + ' ' + moment(this.release.dateTime ).format('DD MMMM YYYY')
      }
      return ''
    }
  },
  filters: {
    formatDate(value) {
      if (value) {
        return moment(value).format('DD MMMM YYYY')
      }
    }
  },
  methods: {
    applySearch(search, items) {
      this.search = search
      this.fiterReleases(items)
    },
    filterByTypes(val) {
      this.type_filter = val ? val[0] : this.type_filter
      this.fiterReleases()
    },
    fiterReleases(items) {

      let features = items || this.release.features?.slice(0) || []
      if (this.search || this.type_filter) {
        features = features?.filter(feature => {
          let type = this.type_filter,
            type_condition = !type || ( type.contain ? feature.type == type.search : feature.type != type.search),
            search_condition = !this.search || this.$_.some(Object.entries(feature), ([key, value]) =>
              typeof value == 'string' && key != 'id' ? value.toLowerCase().includes(this.search?.toLowerCase()) : false)
          return type_condition && search_condition
        })
      }
      this.filtred_features = this.$_.sortBy(features, 'number')
    },
    async infinityLoad(beginning) {
      if ( beginning ) {
        this.count = 0
      }

      this.loadi_features = true
      await this.$store.dispatch('getFeatures', {releaseId: this.release.id, take: this.per_page, skip: this.count})
        .then(res => {
          if ( beginning ) {
            this.release.features = res
          } else {
            this.release.features ||= []
            this.release.features.push(...res)
          }
          this.count += res?.length
          this.fiterReleases()
          this.features = this.release.features
          this.loadi_features = false
        })
    }
  },
  watch: {
    async release(val, old) {
      if ( val && val.id && val.id != old.id && val.count ) {
        this.loading = true
        await this.infinityLoad(true)
        this.loading = false
      }

    }
  },
  components: {
    FilterBar,
    TypeSelect,
    FeatureCard,
    CreateRelease,
    MenuComponent,
    ReleasesNavBar,
    InfinityUpdater
  }
}
</script>
<style lang="scss" scoped>
.empty-block {
  border-radius: 8px ;
}
</style>
